import React from 'react';

import {
  View,
  Link,
  Card,
  CardHeader,
  CardContent,
  DescriptionList,
  DescriptionItem,
  TypographyListItem,
  Typography,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import IODetails from 'scenes/IO/components/IODetails/IODetails';
import IOTitle from 'scenes/IO/components/IOTitle';

const IoItem = ({ id, businessPartner, period, onClick }) => {
  const handleOpenIO = () => onClick(id);
  return (
    <TypographyListItem
      tooltip={<IOTitle businessPartner={businessPartner} period={period} />}
    >
      <Link key={id} onClick={handleOpenIO}>
        <IOTitle businessPartner={businessPartner} period={period} />
      </Link>
    </TypographyListItem>
  );
};

const FinancialResultSpend = ({ loading, data = {}, error }) => {
  const [childComponent, openChildComponent] = useChildComponent();
  const handleOpenIO = (id) => {
    openChildComponent(IODetails, {
      id: id,
    });
  };

  return (
    <View fetching={loading}>
      <Card elevation={6}>
        <CardHeader title={'Business Partner Activities'} />
        <CardContent>
          {error ? (
            <Typography color={'error'}>{error}</Typography>
          ) : (
            <DescriptionList
              stripEmpty={true}
              data={data}
              disableGutters={true}
            >
              <DescriptionItem
                label={'Currency'}
                field={'originalSpend.currencyCode'}
                valueParser={(v) => v?.toUpperCase()}
                placeholder={'—'}
              />
              <DescriptionItem
                label={'Spend'}
                field={'spend'}
                type={'amount'}
                placeholder={'—'}
              />
              <DescriptionItem
                label={'Original spend'}
                field={'originalSpend'}
                type={'amount'}
                placeholder={'—'}
              />
              <DescriptionItem
                label={'Payment term'}
                field={'paymentTerm'}
                placeholder={'—'}
              />
              <DescriptionItem
                label={'Current IOs'}
                field={'io'}
                type={'typographyList'}
                item={IoItem}
                onItemClick={handleOpenIO}
                placeholder={'—'}
              />
            </DescriptionList>
          )}
        </CardContent>
      </Card>
      {childComponent}
    </View>
  );
};

export default FinancialResultSpend;
